import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage'; 
import Header from './components/Header';
import Footer from './components/Footer';
import FormManagement from './pages/FormManagement';
import AboutUs from './pages/AboutUs';
import HowItWorks from './pages/HowItWorks';
import Cookie from './pages/Cookie';
import Terms from './pages/Terms';
import Policy from './pages/Policy';
import RefundPolicy from './pages/RefundPolicy';
import Contact from './pages/Contact';
import Verification from './pages/Verification';
import Travel from './pages/Travel';
// import InvoicePayments from './pages/InvoicePayments';
import ManageInvoices from './pages/ManageInvoices';
import NotFound from './pages/NotFound';  // Import the NotFound page

const App = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/travel" element={<Travel />} />
        {/* <Route path="/start-claim" element={<StartClaim />} />  */}
        <Route path="/about" element={<AboutUs />} /> 
        <Route path="/how-it-works" element={<HowItWorks />} /> 
        {/* <Route path="/why-us" element={<WhyAC />} /> */}
        <Route path="/terms-of-service" element={<Terms />} /> 
        <Route path="/privacy-policy" element={<Policy />} /> 
        <Route path="/refund-policy" element={<RefundPolicy />} /> 
        <Route path="/cookie-policy" element={<Cookie />} /> 
        <Route path="/contact" element={<Contact />} />
        {/* <Route path="/invoice/payments" element={<InvoicePayments />} /> */}
        <Route path="/invoice/manage" element={<ManageInvoices />} />
        <Route path="/forms/jndfe8939434ndfd" element={<FormManagement />} />
        {/* Catch-all route for 404 pages */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
